import { Checkbox, Form } from 'antd';

import { TFieldProps } from 'types';

const { Item } = Form;

export const FormCheckbox = ({
  name,
  extra,
  label,
  rules,
  hidden,
  tooltip,
  disabled,
  inputStyles,
  itemClassName,
  onCheckboxChange,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    extra={extra}
    rules={rules}
    hidden={hidden}
    tooltip={tooltip}
    labelAlign='left'
    style={inputStyles}
    className={itemClassName}
    valuePropName='checked'
  >
    <Checkbox
      disabled={disabled}
      onChange={onCheckboxChange}
    >
      {label}
    </Checkbox>
  </Item>
);
